import { useEffect, useState } from 'react';
import type { WidgetProps } from '@frontend/widgets/types';
import { fetchWidgetData } from '../api';

interface FileActivity {
	id: string | number;
	message: string;
	datetime: string | null;
	link: string | null;
}

export default function NextcloudRecentFilesWidget({ contextType, contextId, ecosystemId }: WidgetProps) {
	const [files, setFiles] = useState<FileActivity[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		setLoading(true);
		setError('');
		const params: Record<string, string> = { ecosystemId, contextType, contextId };

		fetchWidgetData<{ files: FileActivity[] }>('nextcloud-recent-files', params)
			.then((d) => setFiles(d.files || []))
			.catch((err: Error) => setError(err.message))
			.finally(() => setLoading(false));
	}, [contextType, contextId, ecosystemId]);

	if (loading) return <div className="widget-inner-loading">Loading files…</div>;
	if (error) return <div className="widget-inner-error">{error}</div>;
	if (!files.length) return <div className="widget-inner-empty">No recent file activity.</div>;

	return (
		<ul className="widget-list">
			{files.map((f, i) => (
				<li key={i} className="widget-list-item">
					<div className="widget-list-primary">
						{f.link
							? <a href={f.link} target="_blank" rel="noopener noreferrer">{f.message}</a>
							: <span>{f.message}</span>
						}
					</div>
					<div className="widget-list-meta">
						{f.datetime && <span>{new Date(f.datetime).toLocaleDateString()}</span>}
					</div>
				</li>
			))}
		</ul>
	);
}
